import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["ruleSelect", "ruleValue", "customizeLink"]

  customize() {
    // Show all rule select dropdowns and enable them
    this.ruleSelectTargets.forEach(select => {
      select.removeAttribute("disabled")
      select.classList.remove("d-none")
    })

    // Hide all rule value spans
    this.ruleValueTargets.forEach(span => {
      span.classList.add("d-none")
    })

    // Hide the customize link itself
    this.customizeLinkTarget.classList.add("d-none")
  }
}